import { useCallback } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import { RouterStore } from '../router-store/index.tsx';
import type {
	EntireRouterState,
	AllRouterActions,
	HistoryUpdateType,
} from '../router-store/types.tsx';

const useCreatePathParamHook = createHook<
	EntireRouterState,
	AllRouterActions,
	string,
	{ paramKey: string }
>(RouterStore, {
	selector: ({ match: { params } }, { paramKey }: { paramKey: any }): string =>
		params[paramKey] as string,
});

/**
 * Utility hook for accessing URL path params
 */
export const usePathParam = (
	paramKey: string,
): [string | undefined, (newValue: string | undefined, updateType?: HistoryUpdateType) => void] => {
	const [paramVal, routerActions] = useCreatePathParamHook({ paramKey });

	const setPathParam = useCallback(
		(newValue: string | undefined, updateType?: HistoryUpdateType) => {
			routerActions.updatePathParam({ [paramKey]: newValue }, updateType);
		},
		[paramKey, routerActions],
	);

	return [paramVal, setPathParam];
};
